<template>
  <v-row v-show="showTimeLimit">
    <v-col cols="12" class="pb-0">
      <div class="tertiary--text text-body-2">
        {{ 
          $t(
          'fleet_management.agents.agent_detail.partials.card_field_window'
          )
        }}
      </div>
    </v-col>
    <v-col>
      <v-row>
        <v-col md="3" v-if="showDays">
          <div class="tertiary--text text-body-2">
            {{ 
              $t(
              'fleet_management.agents.agent_detail.partials.card_field_days'
              )
            }}
          </div>
          <v-select
            id="idEventosDias"
            v-model="timeObj.days"
            item-value="value"
            required
            :readonly="!editMode || isValidConditions('days')"
            hide-details="auto"
            item-text="time"
            return-object
            :items="days"
            :rules="timeRules"
            @change="timeEmit"
            color="tertiary"
            append-icon="mdi-alarm"
            @input="timeRestrictionInp"
          ></v-select>
        </v-col>
        <v-col md="3" v-if="showHours">
          <div class="tertiary--text text-body-2">
            {{ 
              $t(
              'fleet_management.agents.agent_detail.partials.card_field_hours'
              )
            }}
          </div>
          <v-select
            id="idEventosHoras"
            v-model="timeObj.hours"
            return-object
            item-value="value"
            required
            :readonly="!editMode || isValidConditions('hours')"
            hide-details="auto"
            item-text="time"
            :items="hours"
            :rules="timeRules"
            @change="timeEmit"
            color="tertiary"
            append-icon="mdi-alarm"
            @input="timeRestrictionInp"
          ></v-select>
        </v-col>
        <v-col md="3">
          <div class="tertiary--text text-body-2">
            {{ 
              $t(
              'fleet_management.agents.agent_detail.partials.card_field_minutes'
              )
            }}
          </div>
          <v-select
            id="idEventosMinutos"
            v-model="timeObj.minutes"
            return-object
            item-value="value"
            required
            :readonly="!editMode"
            hide-details="auto"
            item-text="time"
            :items="minutes"
            :rules="timeRules"
            @change="timeEmit"
            color="tertiary"
            append-icon="mdi-alarm"
            @input="timeRestrictionInp"
          ></v-select>
        </v-col>
        <v-col md="3" v-if="showSeconds">
          <div class="tertiary--text text-body-2">
            {{ 
              $t(
              'fleet_management.agents.agent_detail.partials.card_field_seconds'
              )
            }}
          </div>
          <v-select
            id="idEventosSegundos"
            v-model="timeObj.seconds"
            return-object
            item-value="value"
            required
            :readonly="!editMode"
            hide-details="auto"
            item-text="time"
            :items="seconds"
            :rules="timeRules"
            @change="timeEmit"
            color="tertiary"
            append-icon="mdi-alarm"
            @input="timeRestrictionInp"
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="conditionNoReportSelected && conditionSpeedSelected">
        <v-col class="warning--text">
          {{ 
            $t(
            'fleet_management.agents.agent_detail.partials.message_minimum_requires_only_tolerance_minutes'
            )
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionSpeedSelected">
        <v-col class="warning--text">
          {{
            $t(
              'fleet_management.agents.time_limit.labels.max_window_speed_limit'
            )
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionRalentiSelected">
        <v-col class="warning--text">
          {{
            $t('fleet_management.agents.time_limit.labels.max_window_ralenti')
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionFuelConsumptionDeviationSelected">
        <v-col class="warning--text">
          {{
            $t(
              'fleet_management.agents.time_limit.labels.max_window_fuel_consumption_deviation'
            )
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionEngineTemperatureSelected">
        <v-col class="warning--text">
          {{
            $t(
              'fleet_management.agents.time_limit.labels.max_and_min_window_engine_temperature'
            )
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionRpmExcessiveSelected">
        <v-col class="warning--text">
          {{
            $t(
              'fleet_management.agents.time_limit.labels.max_and_min_window_rpm_excessive'
            )
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionFuelTankSelected">
        <v-col class="warning--text">
          {{
            $t(
              'fleet_management.agents.time_limit.labels.max_and_min_window_fuel_charge'
            )
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionTemperatureSensorSelected">
        <v-col class="warning--text">
          {{
            $t(
              'fleet_management.agents.time_limit.labels.max_window_temperature_sensor'
            )
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionTemperatureMultiSensorSelected">
        <v-col class="warning--text">
          {{ 
            $t(
            'fleet_management.agents.agent_detail.partials.message_multi_temp_sensor_tolerance'
            )
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionNoReportSelected">
        <v-col class="warning--text">
          {{ 
            $t(
            'fleet_management.agents.agent_detail.partials.message_condition_requires_min_tolerance_hours'
            )
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionSpecialSelected">
        <v-col class="warning--text">
          {{ 
            $t(
            'fleet_management.agents.agent_detail.partials.message_condition_requires_max_tolerance'
            )
          }}
        </v-col>
      </v-row>
      <v-row v-else-if="conditionDetentionSelected">
        <v-col class="warning--text">
          <span v-if="conditions.length < 2 || contactOff"
            >
            {{ 
              $t(
              'fleet_management.agents.agent_detail.partials.message_condition_requires_min_tolerance_minutes'
              )
            }}
          </span
          >
          <span v-else-if="conditions.length > 1 && !contactOff"
            >
            {{ 
              $t(
              'fleet_management.agents.agent_detail.partials.message_condition_requires_min_tolerance_minutes_ten'
              )
            }}
            </span
          >
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { GlobalHelpers } from '@/helpers/mainExports.js'
import { firebaseServices } from '@leapsight/styleguide'
import { FirebaseTagNames } from '@leapsight/portal'
export default {
  name: 'Time Limit',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    dataProp: {
      type: Number,
      default: 0
    },
    conditions: {
      type: Array,
      default(rawProp) {
        return rawProp
      }
    },
    contactOff: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      conditionsSelected: [],
      timeRules: [v => v !== '' || 'Campo Obligatorio'],
      days: [],
      hours: [],
      minutes: [],
      seconds: []
    }
  },
  methods: {
    timeRestrictionInp() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.INP_FLEET_MANAGEMENT_AGENT_TOLERANCE
      )
    },
    isValidConditions(type) {
      if (type === 'days') {
        if (this.conditionSpeedSelected && this.conditionNoReportSelected)
          return false
        if (this.conditionSpecialSelected) return true
        if (this.conditionSpeedSelected) return true
        if (this.conditionNoReportSelected) return false
      }
      if (type === 'hours') {
        if (this.conditionSpeedSelected && this.conditionNoReportSelected)
          return false
        if (this.conditionSpecialSelected) return false
        if (this.conditionSpeedSelected) return true
        if (this.conditionNoReportSelected) return false
      }
      return false
    },

    calculateSchedule() {
      if (!this.conditionSpeedSelected && this.conditionNoReportSelected) {
        if (this.timeObj.days.time == 0 && this.timeObj.hours.time < 2) {
          this.timeObj.hours = { time: 2, value: 7200 }
        }

        if (this.timeObj.days.time > 0) {
          this.hours = this._setHours(24, 0)
        } else {
          this.hours = this._setHours(24, 2)
        }
      }

      if (this.conditionNoReportSelected && this.conditionSpeedSelected) {
        if (this.timeObj.days.time > 0 || this.timeObj.hours.time > 0) {
          this.minutes = this._setMinutes(60, 0, 1)
        } else {
          this.timeObj.minutes = { time: 20, value: 1200 }
          this.minutes = this._setMinutes(60, 20, 1)
        }
      }

      if (this.conditionDetentionSelected) {
        if (this.contactOff) {
          if (
            this.timeObj.days.time == 0 &&
            this.timeObj.hours.time == 0 &&
            this.timeObj.minutes.time < 20
          ) {
            this.timeObj.minutes = { time: 20, value: 1200 }
          }

          if (this.timeObj.days.time > 0 || this.timeObj.hours.time > 0) {
            this.minutes = this._setMinutes(60, 0, 1)
          } else {
            this.minutes = this._setMinutes(60, 20, 1)
          }
        } else {
          if (
            this.timeObj.days.time == 0 &&
            this.timeObj.hours.time == 0 &&
            this.timeObj.minutes.time < 10
          ) {
            Object.assign(this.timeObj.minutes, { time: 10, value: 600 })
            this.timeObj.minutes = { time: 10, value: 600 }
          }

          if (this.timeObj.days.time > 0 || this.timeObj.hours.time > 0) {
            this.minutes = this._setMinutes(60, 0, 1)
          } else {
            if (this.conditions.length > 1) {
              this.minutes = this._setMinutes(60, 10, 1)
            } else {
              this.minutes = this._setMinutes(60, 20, 1)
            }
          }
        }
      }
    },

    timeEmit() {
      //Con el condicional evitamos se pueda seleccionar una tolerancia de 20min 30seg para la condición
      //exceso de velocidad
      if (this.conditionNoReportSelected) {
        this.calculateSchedule()
        this.seconds = this._setSeconds(1)
      } else if (this.conditionDetentionSelected) {
        this.calculateSchedule()
      } else if (this.conditionSpeedSelected) {
        this.timeObj.hours = { time: 0, value: 0 }

        this.hours = this._setHours(24, 0)
        this.minutes = this._setMinutes(21)
        this.seconds = this._setSeconds(2)
      } else if (this.conditionRalentiSelected) {
        this.hours = this._setHours(3)
        this.minutes =
          this.timeObj.hours.value === 0
            ? this._setMinutes(60, 1)
            : this.timeObj.hours.value === 7200
            ? this._setMinutes(1)
            : this._setMinutes(60, 0)
        if (this.timeObj.hours.value === 7200) {
          this.timeObj.minutes = { time: 0, value: 0 }
        }
      } else if (this.conditionFuelConsumptionDeviationSelected) {
        this.timeObj.hours = { time: 0, value: 0 }

        this.hours = this._setHours(24, 0)
        this.minutes = this._setMinutes(21)
        this.seconds = this._setSeconds(2)
        if (this.timeObj.minutes.value === 1200) {
          this.seconds = this._setSeconds(1)
        }
      } else if (this.conditionFuelTankSelected) {
        this.timeObj.hours = { time: 0, value: 0 }

        this.hours = this._setHours(24, 0)
        this.minutes = this._setMinutes(21)
        this.seconds = this._setSeconds(2)
        if (this.timeObj.minutes.value === 1200) {
          this.seconds = this._setSeconds(1)
        }
      } else if (
          this.conditionTemperatureSensorSelected || 
          this.conditionTemperatureMultiSensorSelected
        ) {
        this.timeObj.hours = { time: 0, value: 0 }

        this.hours = this._setHours(24, 0)
        this.minutes = this._setMinutes(31)
        this.seconds = this._setSeconds(2)
        if (this.timeObj.minutes.value === 1800) {
          this.seconds = this._setSeconds(1)
        }
      } else if (this.conditionEngineTemperatureSelected) {
        this.timeObj.hours = { time: 0, value: 0 }
        this.hours = this._setHours(24, 0)
        this.minutes = this._setMinutes(21)
        this.seconds = this._setSeconds(2)

        if (this.timeObj.minutes.value === 1200) {
          this.seconds = this._setSeconds(1)

          if (this.timeObj.seconds.value === 30) {
            this.timeObj.seconds = { time: 0, value: 0 }
          }
        }
      } else if (this.conditionRpmExcessiveSelected) {
        this.timeObj.hours = { time: 0, value: 0 }
        this.hours = this._setHours(0)
        this.minutes = this._setMinutes(21, 0)

        const minutesVal = this.timeObj.minutes.value
        if (minutesVal === 0) {
          this.seconds = [{ time: '30', value: 30 }]
          this.timeObj.seconds = { time: 30, value: 30 }
        } else if (minutesVal === 1200) {
          this.seconds = [{ time: '0', value: 0 }]
          this.timeObj.seconds = { time: 0, value: 0 }
        } else {
          this.seconds = [
            { time: '0', value: 0 },
            { time: '30', value: 30 }
          ]
          const allowedValues = [0, 30]
          if (!allowedValues.includes(this.timeObj.seconds?.value)) {
            this.timeObj.seconds = { time: 0, value: 0 }
          }
        }
      }  else if (
      this.conditionSpecialSelected &&
      this.timeObj.hours.time == 10
      ) {
        this.timeObj.seconds = {
          time: 0,
          value: 0
        }
        this.timeObj.minutes = {
          time: 0,
          value: 0
        }
        this.minutes = this._setMinutes(1)
        this.seconds = this._setSeconds(1)
      } else {
        this.seconds = this._setSeconds()
      }

      const sum =
        this.timeObj.days.value +
        this.timeObj.hours.value +
        this.timeObj.minutes.value +
        this.timeObj.seconds.value

      this.$emit('timeEmit', sum)
    },

    parseTime(window) {
      const days = Math.floor(window / (3600 * 24))
      const hours = Math.floor((window % (3600 * 24)) / 3600)
      const minutes = Math.floor((window % 3600) / 60)
      const seconds = Math.floor(window % 60)

      return {
        days: {
          time: days,
          value: days * 24 * 3600
        },
        hours: {
          time: hours,
          value: hours * 3600
        },
        minutes: {
          time: minutes,
          value: minutes * 60
        },
        seconds: {
          time: seconds,
          value: seconds
        }
      }
    },

    _setDays(max = 8) {
      const allDays = []
      for (let index = 0; index < max; index++) {
        const time = {
          time: index,
          value: index * 24 * 3600
        }
        allDays.push(time)
      }
      return allDays
    },

    _setHours(max = 24, min = 0) {
      const allHours = []
      for (let index = min; index < max; index++) {
        const time = {
          time: `${index}`,
          value: index * 3600
        }
        allHours.push(time)
      }
      return allHours
    },

    _setMinutes(max = 60, min = 0, jump = 1) {
      const allMinutes = []
      for (let index = min; index < max; index += jump) {
        const time = {
          time: `${index}`,
          value: index * 60
        }
        allMinutes.push(time)
      }
      return allMinutes
    },

    _setSeconds(max = 2) {
      const allSeconds = []
      for (let index = 0; index < max; index++) {
        const time = {
          time: index == 0 ? `${index}` : '30',
          value: index == 0 ? index : 30
        }
        allSeconds.push(time)
      }

      return allSeconds
    },

    _resetSpeedWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        })
      }
      this.minutes = this._setMinutes(21)
    },

    _resetRalentiWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 10, value: 600 },
          seconds: { time: 0, value: 0 }
        })
      }
      this.hours = this._setHours(3, 0)
    },

    _resetFuelConsumptionDeviationWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        })
      }
      this.minutes = this._setMinutes(21)
    },

    _resetEngineTemperatureWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        })
      }
      this.minutes = this._setMinutes(21)
    },

    _resetRpmExcessiveWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        })
      }
      this.minutes = this._setMinutes(21)
    },

    _resetFuelTankWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        })
      }
      this.minutes = this._setMinutes(21)
    },

    _resetTemperatureSensorWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        })
      }
      this.minutes = this._setMinutes(31)
    },

    _resetTemperatureMultiSensorWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        })
      }
      this.minutes = this._setMinutes(31)
    },

    _resetDetentionWindow() {
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: {
            time: this.conditions.length < 2 || this.contactOff ? 20 : 10,
            value: this.conditions.length < 2 || this.contactOff ? 1200 : 600
          },
          seconds: { time: 0, value: 0 }
        })
      }
      if (this.conditions.length > 1) {
        if (this.contactOff) {
          this.minutes = this._setMinutes(60, 20, 1)
        } else {
          this.minutes = this._setMinutes(60, 10, 1)
        }
      } else if (this.conditions.length < 2 || this.timeObj.minutes < 20) {
        this.minutes = this._setMinutes(60, 20, 1)
      }
    },

    _resetSpeedInNoReportWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 20, value: 1200 },
          seconds: { time: 0, value: 0 }
        })
      }
      this.minutes = this._setMinutes(60, 20, 1)
    },

    _resetNoReportWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 1, value: 7200 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        })
      }
    },

    _resetSpecialWindow() {
      //Volver a inicializar los valores solo es necesario durante la pantalla de creación de agente
      if (this.$route.name == 'agent-create') {
        Object.assign(this.timeObj, {
          days: { time: 0, value: 0 },
          hours: { time: 0, value: 0 },
          minutes: { time: 0, value: 0 },
          seconds: { time: 0, value: 0 }
        })
      }
      this.hours = this._setHours(11, 0)
    },

    setAllValues() {
      this.days = this._setDays()
      this.minutes = this._setMinutes()
      this.hours = this._setHours(24, 0)
      this.seconds = this._setSeconds()
    },

    isAgentDetail() {
      if (this.$route.name !== 'AgentDetail' || this.conditionRalentiSelected) {
        this.timeEmit()
      }
    }
  },

  computed: {
    showSeconds() {
      const condition = (this.conditions[0] ?? '').split(':')[2] ?? null
      return (
        this.conditionSpeedSelected ||
        !(
          GlobalHelpers.isDetention(condition) ||
          GlobalHelpers.isIgnition(condition) ||
          GlobalHelpers.isGeofence(condition) ||
          condition === 'ralenti'
        )
      )
    },
    showDays() {
      return (
        !this.conditionRalentiSelected &&
        !this.conditionSpeedSelected &&
        !this.conditionFuelConsumptionDeviationSelected &&
        !this.conditionTemperatureSensorSelected &&
        !this.conditionTemperatureMultiSensorSelected &&
        !this.conditionFuelTankSelected &&
        !this.conditionEngineTemperatureSelected &&
        !this.conditionRpmExcessiveSelected
      )
    },
    showHours() {
      return (
        !this.conditionSpeedSelected &&
        !this.conditionFuelConsumptionDeviationSelected &&
        !this.conditionTemperatureSensorSelected &&
        !this.conditionTemperatureMultiSensorSelected &&
        !this.conditionFuelTankSelected &&
        !this.conditionEngineTemperatureSelected &&
        !this.conditionRpmExcessiveSelected
      )
    },
    showTimeLimit() {
      const isSecurityEvents = this.conditions.some(
        e =>
          e == 'mrn:agent_condition:panic_button' ||
          e == 'mrn:agent_condition:driver_door' ||
          e == 'mrn:agent_condition:driver_door_normal' ||
          e == 'mrn:agent_condition:cargo_gate' ||
          e == 'mrn:agent_condition:cargo_gate_normal' ||
          e == 'mrn:agent_condition:semi_detach' ||
          e == 'mrn:agent_condition:semi_detach_normal' ||
          e == 'mrn:agent_condition:tamper_sensor' ||
          e == 'mrn:agent_condition:fuel_cut_off' ||
          e == 'mrn:agent_condition:lasso_disconnected' ||
          e == 'mrn:agent_condition:generic_unauthorized_stop' ||
          e == 'mrn:agent_condition:generic_put_into_service' ||
          e == 'mrn:agent_condition:generic_taken_out_of_service' ||
          e == 'mrn:agent_condition:generic_still_detached' ||
          e == 'mrn:agent_condition:generic_event_test' ||
          e == 'mrn:agent_condition:generic_seat_passenger' ||
          e == 'mrn:agent_condition:generic_delivery' ||
          e == 'mrn:agent_condition:generic_sharped_turn' ||
          e == 'mrn:agent_condition:generic_hard_brake' ||
          e == 'mrn:agent_condition:generic_hard_acceleration'
      )
      return !isSecurityEvents
    },
    conditionSpeedSelected() {
      let hasConditionSpeedLimit = false

      hasConditionSpeedLimit = this.conditions.some(
        condition => condition == 'mrn:agent_condition:speed_limit'
      )
      if (hasConditionSpeedLimit) {
        this.$nextTick(() => {
          this._resetSpeedWindow()
          this.isAgentDetail()
        })
      } else {
        this.setAllValues()
      }

      return hasConditionSpeedLimit
    },
    conditionRalentiSelected() {
      let hasConditionRalenti = false

      hasConditionRalenti = this.conditions.some(
        condition => condition == 'mrn:agent_condition:ralenti'
      )
      if (hasConditionRalenti) {
        this.$nextTick(() => {
          this._resetRalentiWindow()
          this.isAgentDetail()
        })
      } else {
        this.setAllValues()
      }

      return hasConditionRalenti
    },
    conditionFuelConsumptionDeviationSelected() {
      let hasConditionFuelConsumptionDeviation = false

      hasConditionFuelConsumptionDeviation = this.conditions.some(
        condition =>
          condition == 'mrn:agent_condition:fuel_consumption_deviation'
      )
      if (hasConditionFuelConsumptionDeviation) {
        this.$nextTick(() => {
          this._resetFuelConsumptionDeviationWindow()
          this.isAgentDetail()
        })
      } else {
        this.setAllValues()
      }

      return hasConditionFuelConsumptionDeviation
    },
    conditionEngineTemperatureSelected() {
      let hasConditionEngineTemperature = false

      hasConditionEngineTemperature = this.conditions.some(
        condition =>
          condition == 'mrn:agent_condition:engine_temperature'
      )
      if (hasConditionEngineTemperature) {
        this.$nextTick(() => {
          this._resetEngineTemperatureWindow()
          this.isAgentDetail()
        })
      } else {
        this.setAllValues()
      }

      return hasConditionEngineTemperature
    },
    conditionRpmExcessiveSelected() {
      let hasConditionRpmExcessive = false

      hasConditionRpmExcessive = this.conditions.some(
        condition =>
          condition == 'mrn:agent_condition:excessive_rpm'
      )
      if (hasConditionRpmExcessive) {
        this.$nextTick(() => {
          this._resetRpmExcessiveWindow()
          this.isAgentDetail()
        })
      } else {
        this.setAllValues()
      }

      return hasConditionRpmExcessive
    },
    conditionFuelTankSelected() {
      let hasConditionFuelTank = false

      hasConditionFuelTank = this.conditions.some(
        condition => condition == 'mrn:agent_condition:fuel_charge'
      )
      if (hasConditionFuelTank) {
        this.$nextTick(() => {
          this._resetFuelTankWindow()
          this.isAgentDetail()
        })
      } else {
        this.setAllValues()
      }

      return hasConditionFuelTank
    },
    conditionTemperatureSensorSelected() {
      let hasConditionTemperatureSensor = false

      hasConditionTemperatureSensor = this.conditions.some(
        condition => condition == 'mrn:agent_condition:temperature'
      )
      if (hasConditionTemperatureSensor) {
        this.$nextTick(() => {
          this._resetTemperatureSensorWindow()
        })
      } else {
        this.setAllValues()
      }

      return hasConditionTemperatureSensor
    },
    conditionTemperatureMultiSensorSelected() {
      let hasConditionTemperatureMultiSensor = false

      hasConditionTemperatureMultiSensor = this.conditions.some(
        condition => condition == 'mrn:agent_condition:multi_temperature'
      )
      if (hasConditionTemperatureMultiSensor) {
        this.$nextTick(() => {
          this._resetTemperatureMultiSensorWindow()
        })
      } else {
        this.setAllValues()
      }

      return hasConditionTemperatureMultiSensor
    },
    conditionNoReportSelected() {
      let hasConditionSpeedLimit = false
      let hasConditionNoReport = false

      hasConditionNoReport = this.conditions.some(
        condition => condition == 'mrn:agent_condition:no_report'
      )
      if (hasConditionNoReport) {
        hasConditionSpeedLimit = this.conditions.some(
          e => e == 'mrn:agent_condition:speed_limit'
        )

        this.$nextTick(() => {
          if (!hasConditionSpeedLimit) {
            this._resetNoReportWindow()
            this.isAgentDetail()
          } else {
            this._resetSpeedInNoReportWindow()
            this.isAgentDetail()
          }
        })
      } else {
        this.setAllValues()
      }

      return hasConditionNoReport
    },
    conditionDetentionSelected() {
      let hasDetention = false

      hasDetention = this.conditions.some(
        condition => condition == 'mrn:agent_condition:detention'
      )

      if (hasDetention) {
        this.$nextTick(() => {
          this._resetDetentionWindow()
          this.isAgentDetail()
        })
      } else {
        this.setAllValues()
      }
      return hasDetention
    },
    conditionSpecialSelected() {
      let hasMainPowerIngnition = false
      let hasSpeedLimit = false
      let hasNoReport = false
      let hasDetention = false

      hasMainPowerIngnition = this.conditions.some(condition => {
        condition == 'mrn:agent_condition:main_power' ||
          condition == 'mrn:agent_condition:ignition'
      })
      hasSpeedLimit = this.conditions.some(
        condition => condition == 'mrn:agent_condition:speed_limit'
      )
      hasNoReport = this.conditions.some(
        condition => condition == 'mrn:agent_condition:no_report'
      )
      hasDetention = this.conditions.some(
        condition => condition == 'mrn:agent_condition:detention'
      )

      this.$nextTick(() => {
        if (hasMainPowerIngnition) {
          if (!hasSpeedLimit && !hasNoReport && !hasDetention) {
            this._resetSpecialWindow()
            this.isAgentDetail()
          }
        }
      })
      //Si la condición cambió a solo geofensa se reestablecen los valores iniciales
      if (hasSpeedLimit) return false
      if (hasNoReport) return false
      if (hasDetention) return false

      return hasMainPowerIngnition
    },
    timeObj() {
      return this.parseTime(this.dataProp)
    }
  },
  mounted() {
    this.setAllValues()
    this.isAgentDetail()
  }
}
</script>

<style lang="scss" scoped></style>
